export function isLocalHost() {
    if (typeof window !== 'undefined' && window.document !== undefined) {
        if ((window === null || window === void 0 ? void 0 : window.location.hostname) !== undefined &&
            window.location.hostname === 'localhost') {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
